var _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCardDispenser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b,.c{fill:#3c3f45;}.a{opacity:0;}.b{fill-rule:evenodd;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 40,
    height: 40
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M27.5,25.618a1.5,1.5,0,1,0,0-2.236,1.5,1.5,0,1,0,0,2.236ZM27,24.5a.5.5,0,1,0-.5.5A.5.5,0,0,0,27,24.5Zm1.5-.5a.5.5,0,1,1-.5.5A.5.5,0,0,1,28.5,24Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M11,20.5a.5.5,0,0,1-.5-.5V19a.5.5,0,0,1,1,0v1A.5.5,0,0,1,11,20.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M12.5,20a.5.5,0,0,0,1,0V19a.5.5,0,0,0-1,0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M15,20.5a.5.5,0,0,1-.5-.5V19a.5.5,0,0,1,1,0v1A.5.5,0,0,1,15,20.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M17.5,20a.5.5,0,0,0,1,0V19a.5.5,0,0,0-1,0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M20,20.5a.5.5,0,0,1-.5-.5V19a.5.5,0,0,1,1,0v1A.5.5,0,0,1,20,20.5Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M21.5,20a.5.5,0,0,0,1,0V19a.5.5,0,0,0-1,0Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M25,20.5a.5.5,0,0,1-.5-.5V19a.5.5,0,0,1,1,0v1A.5.5,0,0,1,25,20.5Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M26.5,20a.5.5,0,0,0,1,0V19a.5.5,0,0,0-1,0Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M29,20.5a.5.5,0,0,1-.5-.5V19a.5.5,0,0,1,1,0v1A.5.5,0,0,1,29,20.5Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M11,24a.5.5,0,0,0,0,1h5a.5.5,0,0,0,0-1Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M32,13.5A1.5,1.5,0,0,0,30.5,12H9.5A1.5,1.5,0,0,0,8,13.5v13A1.5,1.5,0,0,0,9.5,28h21A1.5,1.5,0,0,0,32,26.5ZM31,14v-.5a.5.5,0,0,0-.5-.5H9.5a.5.5,0,0,0-.5.5V14ZM9,15H31V26.5a.5.5,0,0,1-.5.5H9.5a.5.5,0,0,1-.5-.5Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCardDispenser);
export default __webpack_public_path__ + "static/media/icon-card-dispenser.0edf4e97.svg";
export { ForwardRef as ReactComponent };